import {contextProtection, getName} from '../utils';
import {useContext} from 'react';
import {ModalContext} from './modal-context';

export function useModalContext(this: any) {
	const context = useContext(ModalContext);
	contextProtection(context, getName(this), getName(ModalContext));
	return context;
}
